(() => {
  if (window.__hadiyahVariantCardsInitialized) return;
  window.__hadiyahVariantCardsInitialized = true;

  const railScrollPositions = new Map();
  const pendingRailScrollPositions = new Map();

  document.addEventListener(
    'change',
    (event) => {
      const rail = event.target.closest?.('[data-variant-card-rail]');
      const list = rail?.querySelector('.variant-card-list');
      const railKey = rail?.dataset.variantCardRailKey;
      if (!list || !railKey) return;

      const scrollLeft = list.scrollLeft;
      railScrollPositions.set(railKey, scrollLeft);
      pendingRailScrollPositions.set(railKey, scrollLeft);
    },
    true,
  );

  const initializeVariantCardRails = (root = document) => {
    root.querySelectorAll('[data-variant-card-rail]').forEach((rail) => {
      if (rail.dataset.variantCardRailReady === 'true') return;

      const list = rail.querySelector('.variant-card-list');
      if (!list) return;

      rail.dataset.variantCardRailReady = 'true';
      const railKey = rail.dataset.variantCardRailKey;

      const updateHint = () => {
        const hasOverflow = list.scrollWidth > list.clientWidth + 1;
        const atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 3;
        rail.classList.toggle('variant-card-rail--has-more', hasOverflow && !atEnd);
      };

      const handleScroll = () => {
        if (railKey && !pendingRailScrollPositions.has(railKey)) {
          railScrollPositions.set(railKey, list.scrollLeft);
        }
        updateHint();
      };

      list.addEventListener('scroll', handleScroll, { passive: true });

      if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(updateHint);
        observer.observe(list);
      }

      requestAnimationFrame(() => {
        if (railKey && railScrollPositions.has(railKey)) {
          list.scrollLeft = railScrollPositions.get(railKey);
        }
        updateHint();
      });
    });
  };

  const restoreVariantCardRails = () => {
    initializeVariantCardRails();

    document.querySelectorAll('[data-variant-card-rail]').forEach((rail) => {
      const railKey = rail.dataset.variantCardRailKey;
      const list = rail.querySelector('.variant-card-list');
      if (!railKey || !list) return;

      const savedScrollLeft = pendingRailScrollPositions.has(railKey)
        ? pendingRailScrollPositions.get(railKey)
        : railScrollPositions.get(railKey);
      if (typeof savedScrollLeft !== 'number') return;

      list.scrollLeft = savedScrollLeft;
      requestAnimationFrame(() => {
        list.scrollLeft = savedScrollLeft;
        railScrollPositions.set(railKey, savedScrollLeft);
        pendingRailScrollPositions.delete(railKey);
      });
    });
  };

  const initializeAfterVariantUpdate = () => requestAnimationFrame(restoreVariantCardRails);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeVariantCardRails(), { once: true });
  } else {
    initializeVariantCardRails();
  }

  const variantUpdateEvent =
    typeof MainEvents !== 'undefined' && MainEvents.variantUpdate ? MainEvents.variantUpdate : 'variant:update';

  document.addEventListener(variantUpdateEvent, initializeAfterVariantUpdate);
  document.addEventListener('shopify:section:load', (event) => initializeVariantCardRails(event.target));
})();
